import { render, staticRenderFns } from "./MyBUGList.vue?vue&type=template&id=79b0b1f2&scoped=true&"
import script from "./MyBUGList.vue?vue&type=script&lang=js&"
export * from "./MyBUGList.vue?vue&type=script&lang=js&"
import style0 from "./MyBUGList.vue?vue&type=style&index=0&id=79b0b1f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b0b1f2",
  null
  
)

export default component.exports